module.exports = __webpack_public_path__ + "img/cardinfo.f008d6d7.png";